import { createFeature, createReducer, on } from '@ngrx/store'

import { DesignationState } from './designation.state'
import {
  blockDesignation,
  blockDesignationFailure,
  blockDesignationSuccess,
  createDesignation,
  createDesignationFailure,
  createDesignationSuccess,
  deleteDesignation,
  deleteDesignationFailure,
  deleteDesignationSuccess,
  loadDesignations,
  loadDesignationsFailure,
  loadDesignationsSuccess,
  resetDesignationState,
  updateDesignation,
  updateDesignationFailure,
  updateDesignationSuccess
} from './designation.actions'

export const initialState: DesignationState = {
  totalCount: 0,
  designations: [],
  loading: false,
  error: null,
  totalDepartments: 0
}

// Create the Designation reducer
export const designationReducer = createReducer(
  initialState,
  on(loadDesignations, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadDesignationsSuccess, (state, { totalCount, designations, totalDepartments }) => ({
    ...state,
    totalCount,
    designations,
    loading: false,
    error: null,
    totalDepartments: totalDepartments
  })),
  on(loadDesignationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createDesignation, state => ({ ...state, loading: true })),
  on(createDesignationSuccess, (state, { designation }) => ({
    ...state,
    designations: [...state.designations, designation],
    loading: false,
    totalCount: state.totalCount + 1
  })),
  on(createDesignationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateDesignation, state => ({ ...state, loading: true })),
  on(updateDesignationSuccess, (state, { designation }) => ({
    ...state,
    designation,
    loading: false
  })),
  on(updateDesignationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(blockDesignation, (state, { id }) => ({
    ...state,
    designations: state.designations.map(designation =>
      String(designation.id) === id ? { ...designation, disabled: true } : designation
    )
  })),
  on(blockDesignationSuccess, (state, { designation }) => {
    // Update the business state to reflect that it is blocked
    const updatedState = {
      ...state,
      designations: state.designations.map(
        b => {
          if (b.id === designation.id) {
            console.log('updated business', { ...b, ...designation })
            return { ...b, ...designation }
          } else return b
        } // Update the business object
      ),
      error: null
    }
    return updatedState
  }),
  on(blockDesignationFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(deleteDesignation, (state, { id }) => ({
    ...state,
    designations: state.designations.map(designation =>
      String(designation.id) === id ? { ...designation, disabled: true } : designation
    )
  })),
  on(deleteDesignationSuccess, (state, { id }) => {
    // Update the business state to reflect that it is successfully deleted
    const updatedState = {
      ...state,
      designations: state.designations.filter(b => b.id !== id), // Remove the business from the list
      error: null,
      totalCount: state.totalCount - 1
    }
    return updatedState
  }),
  on(deleteDesignationFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(resetDesignationState, () => initialState)
)

// Create the feature for the Designation state
export const designationFeature = createFeature({
  name: 'designation', // Feature name
  reducer: designationReducer
})
export type { DesignationState }
// Export the feature's selectors
export const {
  name,
  reducer,
  selectDesignations,
  selectLoading,
  selectError,
  selectTotalDepartments
} = designationFeature
